export default {
	state: {
		login: {}
	},
	getters: {
		"login": state => state.login
	},
	mutations: {
		setLogin(state, payload) {
			state.login = payload
		}
	},
	actions: {
		atualizarEstadoLogin({ commit }, payload) {
			commit('setLogin', payload)
		}
	}
};